


















































































































































































































































































import Vue from "vue"
import { PickupDiff } from "@/model/entity/pickup-diff/pickup-diff"
import { countryList } from "@/model/service/country/country-service"
import { addressService, IAddressService } from "@/model/service/address/address-service"
import Datatable, {DatatableOptions} from "@/components/datatable/Datatable.vue"
import { Country } from "@/model/entity/country/country"
import { Address } from "@/model/entity/address/address"
import moment, { Moment } from "moment"
import store from "@/vuex/store"

const cutoffHour = Number(store.state.easyshipConfiguration.pickupDiffDailyLimit)
const MAX_PICKUP_HOUR = 19

const currentDate = new Date()
const currentMoment = moment(currentDate)
const cutoff = moment(currentMoment)
  .hour(cutoffHour)
  .minute(0)
  .second(0)
const weekFromNoonToday = moment(cutoff).add(7, "days")
const firstAvailableDate =
  currentMoment.hour() < cutoffHour
    ? moment(currentMoment).startOf("day")
    : moment(currentMoment)
      .startOf("day")
      .add(1, "days")
let startTime = moment().add(store.state.easyshipConfiguration.pickupDiffNextTimeSlot, "minutes")
const startTimeMinute = startTime.minute()
const startTimeHour = startTime.hour()
startTime = startTime.minute(Math.ceil(startTimeMinute / 15) * 15)
startTime = startTime.hour(startTimeMinute > 45 ? startTimeHour + 1 : startTimeHour)

const endTime = getEndTime(startTime)

function getEndTime(startTime: Moment): Moment {
  let endTime = moment(startTime).add(4, "hours")
  const endTimeMinute = endTime.minute()
  const endTimeHour = endTime.hour()
  endTime = endTime.minute(Math.ceil(endTimeMinute / 15) * 15)
  endTime = endTime.hour(endTimeMinute > 45 ? endTimeHour + 1 : endTimeHour)
  return endTime
}

export default Vue.extend({
  components: {
    Datatable
  },
  data() {
    return {
      earliestPickupDate: firstAvailableDate.toDate(),
      addressService: addressService,
      startTime: moment("08:00", "HH:mm").format("HH:mm"),
      endTime: moment("16:00", "HH:mm").format("HH:mm"),
      pickupDate: firstAvailableDate.toDate(),
      countryList: countryList,
      country: {} as Country,
      startTimeCreated: startTime.format("HH:mm"),
      endTimeCreated: endTime.format("HH:mm"),
      resetAllLocationFields: 0,
      resetAllInfoFields: 0,
      listAddressesDialog: false,
      fields: Address.getFieldDescriptionList(),
      options: {
        dialog: true
      },
      rules: {
        postalCode: [
          {
            max: 9,
            message: `${this.$t("user_administration.max")} 9 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        city: [
          {
            max: 35,
            message: `${this.$t("user_administration.max")} 35 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        street: [
          {
            max: 35,
            message: `${this.$t("user_administration.max")} 35 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        houseNumber: [
          {
            max: 35,
            message: `${this.$t("user_administration.max")} 8 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          }
        ],
        name: [
          {
            max: 35,
            message: `${this.$t("user_administration.max")} 35 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        phone: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: string, callback: (err?: Error) => void) => {
              if (value && !new RegExp(/^[(]?[+]?[0-9 \-\/()]+$/).test(value)) {
                callback(new Error(`${this.$t("user_administration.invalid_format.phone")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          }
        ],
        email: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: string, callback: (err?: Error) => void) => {
              const regexpPattern = /^[\w!#$%&’*+/=?`{|}~^-]+(?:\.[\w!#$%&’*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/
              if (value && !new RegExp(regexpPattern).test(value)) {
                callback(new Error(`${this.$t("user_administration.invalid_format.email")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          }
        ],
        contactName: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          }
        ],
        note: [
          {
            max: 50,
            message: `${this.$t("user_administration.max")} 50 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          }
        ]
      }
    }
  },
  props: {
    carorder: {
      type: Object as () => PickupDiff,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    formsValid: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    emitValidation() {
      const vm = this as any
      let isLocationFormValid
      let isInfoFormValid
      vm.$refs.formLocation.validate(valid => {
        isLocationFormValid = valid
      })
      vm.$refs.formInfo.validate(valid => {
        isInfoFormValid = valid
      })
      this.$emit("update:formsValid", isLocationFormValid && isInfoFormValid)
    },
    reset() {
      this.resetForms()
      if (exists(this.carorder.dateFrom) && exists(this.carorder.dateTo)) {
        this.pickupDate = new Date(this.carorder.dateFrom!)
        this.startTime = moment(this.carorder.dateFrom!).format("HH:mm")
        this.endTime = moment(this.carorder.dateTo!).format("HH:mm")
      }
      this.carorder.countryIsoCode = this.country.isoCodeAlpha2
      this.carorder.pickupTimeFrom = moment(this.startTime, "HH:mm")
        .toDate()
        .getTime()
      this.carorder.pickupTimeTo = moment(this.endTime, "HH:mm")
        .toDate()
        .getTime()
      this.carorder.pickupDate = this.pickupDate.getTime()
      this.carorder.weight = 1
      this.carorder.numberOfParcels = 1
    },
    resetForms() {
      this.resetAllLocationFields++
      this.resetAllInfoFields++
      this.$emit("update:formsValid", false)
    },
    fuzzySearchCity(input: string, callback: any) {
      if (input && input.length >= 3 && this.carorder.countryIsoCode) {
        this.$http
          .get("cities/fuzzy/cities?country_code=" + this.carorder.countryIsoCode + "&city=" + input)
          .then(response => {
            callback(response.data)
          })
      } else {
        callback([])
      }
    },
    fuzzySearchPostalcode(input: string, callback: any) {
      if (input && input.length >= 3 && this.carorder.countryIsoCode) {
        this.$http
          .get("cities/fuzzy/zipcodes?country_code=" + this.carorder.countryIsoCode + "&zipcode=" + input)
          .then(response => {
            callback(response.data)
          })
      } else {
        callback([])
      }
    },
    setCityAndPostalcode(entity: any) {
      this.carorder.city = entity.name
      this.carorder.postalCode = entity.postalCode
      console.log(this.carorder.city)
      console.log(this.carorder.postalCode)
    },
    fuzzySearchName(input: string, callback: any) {
      if (exists(input) && input.length >= 3) {
        this.addressService.fuzzySearchPickup(input).then(response => {
          callback(response.data)
        })
      } else {
        callback([])
      }
    },
    openDialog() {
      this.listAddressesDialog = true
    },
    setAddress(entity: Address) {
      if (entity !== null) {
        this.carorder.name = entity.name
        this.carorder.contactName = entity.contact
        this.carorder.postalCode = entity.zipcode
        this.carorder.city = entity.city
        this.carorder.street = entity.street
        this.carorder.phone = entity.phone
        this.carorder.email = entity.email
        this.carorder.mobile = entity.mobile
        this.carorder.houseNumber = entity.houseNumber
        this.carorder.note = entity.comment
        this.listAddressesDialog = false
      }
      this.$nextTick(() => this.emitValidation())
    },
    nameKeyupHandler(event: KeyboardEvent) {
      if (event.ctrlKey && event.shiftKey && (event.key === "S" || event.key === "s")) {
        event.stopPropagation()
        this.openDialog()
      }
    },
    fetchCutOffTime() {
      console.log(this.carorder)
      const postalCode = this.carorder.postalCode
      const countryId = this.country && this.country.id
      if (!postalCode || !countryId) {
        return
      }
      this.$http
        .get(`cut_off_time/check?postal_code=${encodeURIComponent(postalCode)}&country_id=${countryId}`)
        .then(response => {
          this.applyPickupDate(response.data as number)
        })
        .catch(() => {
          // leave existing pickup date unchanged on failure
        })
    },
    applyPickupDate(cutoffHour: number) {
      const now = moment()
      const useNextDay = now.hour() >= cutoffHour
      const calculated = useNextDay
        ? moment().startOf("day").add(1, "days")
        : moment().startOf("day")
      this.earliestPickupDate = calculated.toDate()
      this.pickupDate = calculated.toDate()
    }
  },
  computed: {
    datePickerOptions(): any {
      const earliest = moment(this.earliestPickupDate).startOf("day")
      return {
        firstDayOfWeek: 1,
        disabledDate(time: Date) {
          const evaluatedMoment = moment(time).startOf("day")
          return evaluatedMoment.isBefore(earliest) || evaluatedMoment.isAfter(weekFromNoonToday)
        }
      }
    },
    pickerOptionsStart(): any {
      const evaluatedDate = moment(this.pickupDate)
      return {
        minTime: evaluatedDate.isSame(currentMoment, "day")
          ? moment()
            .add(store.state.easyshipConfiguration.pickupDiffNextTimeSlot, "minutes")
            .format("HH:mm")
          : "",
        step: "00:15",
        start: "07:00",
        end: "20:45"
      }
    },
    pickerOptionsEnd(): any {
      const evaluatedDate = moment(this.pickupDate)
      return {
        minTime: evaluatedDate.isSame(currentMoment, "day")
          ? moment()
            .add(store.state.easyshipConfiguration.pickupDiffNextTimeSlot, "minutes")
            .format("HH:mm")
          : "",
        step: "00:15",
        start: "07:15",
        end: "21:00"
      }
    }
  },
  watch: {
    startTime: {
      immediate: true,
      handler() {
        const start = moment(this.startTime, "HH:mm")
        const end = moment(this.endTime, "HH:mm")
        if (start.isSameOrAfter(end)) {
          this.endTime = moment(start)
            .add(15, "minutes")
            .format("HH:mm")
        }
        this.carorder.pickupTimeFrom = moment(this.startTime, "HH:mm")
          .toDate()
          .getTime()
      }
    },
    endTime: {
      immediate: true,
      handler() {
        const start = moment(this.startTime, "HH:mm")
        const end = moment(this.endTime, "HH:mm")
        if (end.isSameOrBefore(start)) {
          this.startTime = moment(end)
            .subtract(15, "minutes")
            .format("HH:mm")
        }
        this.carorder.pickupTimeTo = moment(this.endTime, "HH:mm")
          .toDate()
          .getTime()
      }
    },
    carorder: {
      immediate: true,
      handler() {
        if (exists(this.carorder.dateFrom) && exists(this.carorder.dateTo)) {
          this.pickupDate = new Date(this.carorder.dateFrom!)
          this.startTimeCreated = moment(this.carorder.dateFrom).format("HH:mm")
          this.endTimeCreated = moment(this.carorder.dateTo).format("HH:mm")
        }
      }
    },
    countryList: {
      deep: true,
      immediate: true,
      handler() {
        if (this.countryList.length > 0) {
          this.country = this.countryList.find(
            country => country.isoCodeAlpha2 === this.$store.getters.loggedUser.office.country.isoCodeAlpha2
          )!
          this.carorder.countryIsoCode = this.country.isoCodeAlpha2
        }
      }
    },
    pickupDate: {
      immediate: true,
      handler() {
        const isToday = moment(this.pickupDate).isSame(moment(), "day")
        this.startTime = isToday
          ? startTime.format("HH:mm")
          : moment("08:00", "HH:mm").format("HH:mm")
        this.endTime = moment("16:00", "HH:mm").format("HH:mm")
        this.carorder.pickupDate = this.pickupDate.getTime()
      }
    },
    "carorder.postalCode": {
      handler() {
        this.emitValidation()
        this.fetchCutOffTime()
      }
    },
    "country.id": {
      handler() {
        this.fetchCutOffTime()
      }
    },
    "carorder.city": {
      handler() {
        this.emitValidation()
      }
    },
    "carorder.street": {
      handler() {
        this.emitValidation()
      }
    },
    "carorder.houseNumber": {
      handler() {
        this.emitValidation()
      }
    },
    "carorder.name": {
      handler() {
        this.emitValidation()
      }
    },
    "carorder.phone": {
      handler() {
        this.emitValidation()
      }
    },
    "carorder.email": {
      handler() {
        this.emitValidation()
      }
    },
    "carorder.contactName": {
      handler() {
        this.emitValidation()
      }
    },
    "carorder.note": {
      handler() {
        this.emitValidation()
      }
    }
  },
  mounted() {
    this.emitValidation()
  }
})
